<template>
  <div class="md:mx-14 pt-4 mx-5">
    <div v-if="hasLimitedSettings">
      <settings-navigation activeTitle="Profile" />
    </div>
    <div v-if="!hasLimitedSettings">
      <!-- <p
        class="fixed z-50 top-20 font-normal bg-root-1 pt-2 md:pt-0 pb-2 pr-2 pl-3 md:pl-0 md:-ml-2 text-sm lg:text-base text-gray-40"
      >
        Profile
      </p> -->
      <div
        @click="goBack"
        class="border cursor-pointer mb-4 flex items-center justify-center mt-6 rounded-3xl p-2 w-20"
      >
        <back-arrow />
        <p class="text-13px text-root-4 ml-2 font-normal">back</p>
      </div>
    </div>
    <div v-if="isEditView" class="max-w-2xl pt-4 user-card px-10 py-8">
      <div class="text-gray-9">Edit Profile</div>
      <div class="flex pb-4 items-center">
        <avatar-image />
        <div
          class="bg-white cursor-pointer h-10 font-semibold hover:opacity-80 flex text-primary items-center border justify-center border-primary rounded-3xl px-6 py-3 ml-2"
        >
          Change
        </div>
        <div
          class="cursor-pointer font-semibold h-10 hover:opacity-80 flex text-gray-2 items-center justify-center rounded-3xl px-6 py-3 ml-2"
        >
          Remove
        </div>
      </div>
      <el-form
        @keyup.enter.native="validateForm('editProfileForm')"
        label-position="top"
        class=""
        :model="editProfileForm"
        ref="editProfileForm"
        label-width="80px"
        size="normal"
      >
        <div class="grid md:grid-cols-2 gap-x-2">
          <el-form-item label="First Name" prop="firstName">
            <el-input
              name="firstName"
              placeholder="Enter first name"
              v-model="editProfileForm.firstName"
            ></el-input>
          </el-form-item>
          <el-form-item label="Last Name" prop="lastName">
            <el-input
              placeholder="Enter last name"
              v-model="editProfileForm.lastName"
            ></el-input>
          </el-form-item>
        </div>
        <div class="grid md:grid-cols-2 -my-4 gap-x-2">
          <el-form-item label="Email" prop="email">
            <el-input
              testId="email"
              placeholder="name@example.com"
              type="email"
              v-model="editProfileForm.email"
            ></el-input>
          </el-form-item>
          <el-form-item label="Phone Number" prop="phoneNumber">
            <el-input
              testId="phoneNumber"
              placeholder="0908933789"
              type="phoneNumber"
              v-model="editProfileForm.phoneNumber"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item class="w-full" label="Address" prop="address">
          <el-input
            name="address"
            placeholder="Enter address"
            v-model="editProfileForm.address"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="flex justify-end mt-10">
        <div
          @click="isEditView = false"
          class="bg-white text-sm cursor-pointer h-10 font-semibold hover:opacity-80 flex text-root-2 items-center border justify-center border-gray-9 rounded-3xl px-6 py-3 ml-2"
        >
          Discard Changes
        </div>
        <div
          class="cursor-pointer text-sm h-10 font-medium hover:opacity-80 flex text-white items-center border bg-primary justify-center border-primary rounded-3xl px-6 py-3 ml-5"
        >
          Save Changes
        </div>
      </div>
    </div>
    <div v-else class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-6">
      <div class="flex flex-col">
        <div
          v-if="business.name"
          class="user-card mb-4 flex flex-col justify-center items-center bg-center"
        >
          <div class="justify-end w-full mr-4 mt-2 flex">
            <div @click="isEditView = false" class="flex"><edit-icon /></div>
          </div>
          <el-avatar class="text-5xl" :size="110">{{
            business.name.charAt(0).toUpperCase()
          }}</el-avatar>
          <div class="text-root-1 font-bold text-2xl mt-2 pb-8">
            {{ business.name }}
          </div>
        </div>
        <el-collapse accordion v-model="activeNames">
          <el-collapse-item class="" name="1">
            <template slot="title">
              <div class="flex w-full justify-between">
                <div
                  class="lg:ml-4 ml-0 text-black-1 font-semibold flex flex-col"
                >
                  <div class="text-root-1 ml-2">Company Information</div>
                </div>
              </div>
            </template>
            <div v-if="user.firstName && business.email" class="lg:ml-6 ml-3">
              <div class="pr-2 py-3 h-full mr-6">
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Name</div>
                  <div class="text-sm font-semibold">{{ business.name }}</div>
                </div>
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Company Name</div>
                  <div class="text-sm font-semibold">{{ business.name }}</div>
                </div>
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Phone Number</div>
                  <div class="text-sm font-semibold">
                    {{ business.telephone }}
                  </div>
                </div>
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Address</div>
                  <div class="text-sm font-semibold">-</div>
                </div>
                <div
                  class="flex border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Country</div>
                  <div class="text-sm font-semibold">
                    {{ business.countryCode === 'NG' ? 'Nigeria' : '-' }}
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse class="mt-4" accordion v-model="activeNames">
          <el-collapse-item class="" name="2">
            <template slot="title">
              <div class="flex w-full justify-between">
                <div
                  class="lg:ml-4 ml-0 text-black-1 font-semibold flex flex-col"
                >
                  <div class="ml-2 text-root-1">Personal Information</div>
                </div>
              </div>
            </template>
            <div v-if="user.firstName && business.email" class="lg:ml-6 ml-3">
              <div class="pr-2 py-3 h-full mr-6">
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Name</div>
                  <div class="text-sm font-semibold">
                    {{ user.firstName }} {{ user.lastName }}
                  </div>
                </div>
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Role</div>
                  <div class="text-sm font-semibold">{{ user.title }}</div>
                </div>
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Phone Number</div>
                  <div class="text-sm font-semibold">{{ user.telephone }}</div>
                </div>
                <div
                  class="flex pb-3 border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Email Address</div>
                  <div class="text-sm font-semibold">{{ user.email }}</div>
                </div>
                <div
                  class="flex border-t pt-3 justify-between border-color-text-root-3"
                >
                  <div class="text-sm font-normal">Country</div>
                  <div class="text-sm font-semibold">
                    {{ business.countryCode === 'NG' ? 'Nigeria' : '-' }}
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div
        v-if="user.firstName && business.email"
        style="max-height: 362px"
        class="user-card lg:mt-0 text-root-1 mt-4 flex flex-col bg-center"
      >
        <div
          class="justify-start p-4 pl-8 py-6 cursor-pointer border-b border-color-text-root-3 w-full flex"
        >
          Verification and KYC
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-normal">Account Activation</div>
          <div
            :class="
              user.isActive
                ? 'bg-light-blue-1 text-blue-2'
                : 'bg-yellow-1 text-yellow-2'
            "
            class="flex items-center justify-center font-medium text-xs w-24 rounded-2xl"
          >
            <i
              :class="
                user.isActive ? 'el-icon-check mr-2' : 'el-icon-minus mr-2'
              "
            ></i>
            {{ user.isActive ? 'Verified' : 'Pending' }}
          </div>
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-normal">KYC Completed</div>
          <div
            :class="
              business.completedKyc
                ? 'bg-light-blue-1 text-blue-2'
                : 'bg-yellow-1 text-yellow-2'
            "
            class="flex items-center justify-center font-medium text-xs w-24 rounded-2xl"
          >
            <i
              :class="
                business.completedKyc
                  ? 'el-icon-check mr-2'
                  : 'el-icon-minus mr-2'
              "
            ></i>
            {{ business.completedKyc ? 'Verified' : 'Pending' }}
          </div>
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-normal">Account Compliance</div>
          <div
            :class="
              business.accountActive
                ? 'bg-light-blue-1 text-blue-2'
                : 'bg-yellow-1 text-yellow-2 '
            "
            class="flex items-center justify-center font-medium text-xs w-24 bg-light-blue-1 rounded-2xl"
          >
            <i
              :class="
                business.accountActive
                  ? 'el-icon-check mr-2'
                  : 'el-icon-minus mr-2'
              "
            ></i>
            {{ business.accountActive ? 'Verified' : 'Pending' }}
          </div>
        </div>
        <div class="flex px-8 py-4 justify-between">
          <div class="text-sm font-normal">Account Opened</div>
          <div
            :class="
              business.accountActive
                ? 'bg-light-blue-1 text-blue-2'
                : 'bg-yellow-1 text-yellow-2'
            "
            class="flex items-center justify-center font-medium text-xs w-24 rounded-2xl"
          >
            <i
              :class="
                business.accountActive
                  ? 'el-icon-check mr-2'
                  : 'el-icon-minus mr-2'
              "
            ></i>
            {{ business.accountActive ? 'Verified' : 'Pending' }}
          </div>
        </div>
        <div
          v-if="business.accountActive"
          class="flex px-8 py-4 justify-between"
        >
          <div class="text-sm font-normal">Account Opened Since</div>
          <div
            class="bg-light-blue-1 text-blue-2 flex items-center justify-center font-medium text-xs w-24 rounded-2xl"
          >
            <i
              :class="
                business.accountActive
                  ? 'el-icon-check mr-2'
                  : 'el-icon-minus mr-2'
              "
            ></i>
            {{ $dayjs(business.accountActiveSince).format('DD, MMM YYYY') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    EditIcon: () => import('@/assets/icons/EditIcon.vue'),
    avatarImage: () => import('@/assets/images/AvatarImage.vue'),
    BackArrow: () => import('@/assets/icons/BackArrow.vue'),
    SettingsNavigation: () =>
      import('@/components/settings/SettingsNavigation.vue')
  },
  data () {
    return {
      isEditView: false,
      activeNames: [],
      editProfileForm: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: ''
      }
    }
  },
  computed: {
    business () {
      return this.$store.state.auth.business
    },
    user () {
      return this.$store.state.auth.user
    },
    hasLimitedSettings () {
      return process.env.VUE_APP_SETTINGS_LIMITED === 'true'
    }
  },
  methods: {
    goBack () {
      this.$router.push('/settings')
    }
  }
}
</script>

<style scoped>
.border-color-text-root-3 {
  border-color: var(--text-root-3);
}
.user-card {
  background: var(--background);
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}
>>> .el-collapse-item__header {
  height: 80px;
  background: var(--background);
  /* card / floating */
  border-bottom: 0px solid #ebeef5;
  box-shadow: 0px 12px 26px rgba(16, 30, 115, 0.06);
  border-radius: 15px;
}
>>> .el-collapse-item__header.is-active {
  height: 60px;
  background: var(--background);
  /* card / floating */
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
>>> .el-collapse {
  border-top: 0px solid #ebeef5;
  border-bottom: 0px solid #ebeef5;
}
>>> .el-collapse-item__content {
  color: var(--text-1);
  background: var(--background);
}
</style>
